import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  CreateUpdateExamsPackageDto,
  CreateUpdateExamsPackageDtoFromJSON,
  GetExamsPackageDto,
  GetLastEditorDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { ExamPackageType } from '../validation/schemas';
import { examsPackageForGrid } from '../../../spd/components/ExamsPackage/ExamsPackageSearch';

export interface ExamsPackageContextInterface {
  get: (id: string) => Promise<GetExamsPackageDto>;
  getAllMulitipleByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    setRefresh?: () => void,
    onlyWithWaitingExams?: boolean,
  ) => Promise<GridRecord[]>;
  getAllMulitipleCount: (
    filterText?: string,
    filterColumns?: string,
    onlyWithWaitingExams?: boolean,
  ) => Promise<number>;
  getAllSingleByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    setRefresh?: () => void,
  ) => Promise<GridRecord[]>;
  getAllSingleCount: (
    filterText?: string,
    filterColumns?: string,
  ) => Promise<number>;
  deleteExpectationExams: (id: string) => Promise<void>;
  getExpectationPins: (id: string) => Promise<string>;
  update: (id: string, dto: CreateUpdateExamsPackageDto) => Promise<void>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const ExamsPackageContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.examsPackageControllerGet(id);
    },

    getAllMulitipleByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      setRefresh?: () => void,
      onlyWithWaitingExams?: boolean,
    ) => {
      const data = await api.examsPackageControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns || '',
        ExamPackageType.Mulitiple,
        onlyWithWaitingExams,
      );
      return data.map(exPac => examsPackageForGrid(exPac, setRefresh));
    },

    getAllMulitipleCount: (
      filterText?: string,
      filterColumns?: string,
      onlyWithWaitingExams?: boolean,
    ) =>
      api.examsPackageControllerGetAllCount(
        filterText || '',
        filterColumns || '',
        ExamPackageType.Mulitiple,
        onlyWithWaitingExams,
      ),

    getAllSingleByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      setRefresh?: () => void,
    ) => {
      const data = await api.examsPackageControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns || '',
        ExamPackageType.Single,
      );
      return data.map(exPac => examsPackageForGrid(exPac, setRefresh));
    },

    getAllSingleCount: (filterText?: string, filterColumns?: string) =>
      api.examsPackageControllerGetAllCount(
        filterText || '',
        filterColumns || '',
        ExamPackageType.Single,
      ),

    deleteExpectationExams: (examPackageId: string) =>
      api.examsPackageControllerDeleteExpectationExams(examPackageId),

    getExpectationPins: (examPackageId: string) =>
      api.examsPackageControllerGetExpectationPins(examPackageId),

    update: (id: string, dto: CreateUpdateExamsPackageDto) =>
      api.examsPackageControllerUpdate(id, dto),

    getLastEditor: (id: string) => api.examsPackageControllerGetLastEditor(id),
  };
};

export const examsPackageData = (
  exPa?: GetExamsPackageDto,
): CreateUpdateExamsPackageDto => {
  return CreateUpdateExamsPackageDtoFromJSON({
    ...exPa,
    companyId: exPa?.company?.id || '',
    healthcareFacilityId: exPa?.healthcareFacility?.id || '',
  });
};
